module.exports = __webpack_public_path__ + "static/media/link-copied-icon.d69b74ec.svg";